import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { AuthService } from '../../services/auth.service';

@Component({
    selector: 'app-callback',
  template: '<p>Processing login...</p>',
  standalone: true
})
export class CallbackComponent implements OnInit {
  constructor(
    private readonly authService: AuthService,
    private readonly router: Router,
  ) {}

  async ngOnInit() {
    try {
      await this.authService.handleCallback();
    } catch (error) {
      if (environment.verboseLogging) {
        console.error('Callback error:', error);
      }

      const errorMessage = this.getErrorMessage(error);

      this.router.navigate(['/login'], {
        state: { error: errorMessage },
      });
    }
  }

  private getErrorMessage(error: unknown): string {
    const message = this.getErrorText(error);

    const statusMatch = /\b([45]\d{2})\b/.exec(message);
    if (statusMatch) {
      const status = Number.parseInt(statusMatch[1], 10);

      if (status >= 500) {
        return 'Our servers are experiencing issues. Please try again later.';
      }

      if (status >= 400) {
        return 'Authentication failed. Please try again.';
      }
    }

    return 'Something went wrong. Please try again.';
  }

  private getErrorText(error: unknown): string {
    if (error instanceof Error) {
      return error.message;
    }

    if (typeof error === 'string') {
      return error;
    }

    if (error && typeof error === 'object') {
      try {
        return JSON.stringify(error);
      } catch {
        return '';
      }
    }

    return '';
  }
}
